export default "__VITE_ASSET__BES5hylq__"